import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import UpdateIcon from "src/components/shared/icon/UpdateIcon";
import useAppGlobal from "src/context/useAppGlobal";
import useEmployeeRemove from "src/hooks/user/useEmployeeRemove";
import { v4 as uuid } from "uuid";
import UserCreate from "../UserCreate";
import useAuthGlobal from "src/context/useAuthGlobal";
import { canMutateEmployeeRows } from "./employeeAccess";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import useQueryParams from "src/hooks/useQueryParams";
import { USER_TYPE } from "src/constant";

export default function useCustomerAction() {
  const permissionCheck = useRoleCheck();
  const [option] = useQueryParams();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [customerId, setCustomerId] = useState();
  const { trigger: removeCustomer } = useEmployeeRemove(customerId);
  const { userMe } = useAuthGlobal();
  const canMutate = canMutateEmployeeRows(userMe?.role?.code);
  const updatePermissions =
    option?.tab === USER_TYPE.Sales
      ? [PERMISSIONS.UPDATE_SALES_ALL, PERMISSIONS.UPDATE_SALES_OWN]
      : option?.tab === USER_TYPE.SalesChannel
        ? [PERMISSIONS.UPDATE_USER_ALL, PERMISSIONS.UPDATE_USER_OWN, PERMISSIONS.UPDATE_SALES_ALL, PERMISSIONS.UPDATE_SALES_OWN]
        : [PERMISSIONS.UPDATE_USER_ALL, PERMISSIONS.UPDATE_USER_OWN];
  const deletePermissions =
    option?.tab === USER_TYPE.Sales
      ? [PERMISSIONS.DELETE_SALES_ALL, PERMISSIONS.DELETE_SALES_OWN]
      : option?.tab === USER_TYPE.SalesChannel
        ? [PERMISSIONS.DELETE_USER_ALL, PERMISSIONS.DELETE_USER_OWN, PERMISSIONS.DELETE_SALES_ALL, PERMISSIONS.DELETE_SALES_OWN]
        : [PERMISSIONS.DELETE_USER_ALL, PERMISSIONS.DELETE_USER_OWN];

  const handleCustomerUpdate = (item) => {
    handleOpenDialog({
      title: "Cập nhật nhân viên",
      size: "md",
      content: (
        <UserCreate
          key={uuid()}
          item={item}
        />
      ),
    });
  };

  const handleCustomerRemove = async (item) => {
    const res = await removeCustomer({
      body: { id: item?._id },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const action = [
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleCustomerUpdate(item),
      type: "icon",
      disabled: !canMutate || !permissionCheck(updatePermissions),
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      onClick: (item) => {
        setCustomerId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.fullName}
              onConfirm={() => handleCustomerRemove(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
      disabled: !canMutate || !permissionCheck(deletePermissions),
    },
  ];
  return action;
}
